import React from "react";
import { styled } from "@mui/material/styles";
import { Typography } from "@mui/material";

const StyledGradientText = styled(Typography)(({ gradient }) => ({
  background: gradient,
  backgroundClip: "text",
  WebkitBackgroundClip: "text",
  WebkitTextFillColor: "transparent",
  display: "inline-block",
  fontWeight: 600,
}));

const GradientText = ({
  children,
  gradient = "linear-gradient(135deg, #A7C0FF 0%, #497DFF 100%)",
  component = "span",
  ...props
}) => {
  return (
    <StyledGradientText component={component} gradient={gradient} {...props}>
      {children}
    </StyledGradientText>
  );
};

export default GradientText;

// Usage examples:
// <GradientText gradient="linear-gradient(45deg, #FF6B6B, #4ECDC4)">
//   Hello World
// </GradientText>
//
// <GradientText
//   variant="h4"
//   gradient="linear-gradient(135deg, #667eea 0%, #764ba2 100%)"
// >
//   Gradient Title
// </GradientText>
